import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import { CustomerTransaksi } from '../componen/CustomerTransaksi';

export const CustomerTransaksiPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
   <Layout>
    <CustomerTransaksi />
   </Layout>

  )
}
